import axios from "axios";

import { RootState } from "../app/store";
import { FetchQuestionnairesParams } from "./questionnaire/questionnaireSlice";

export const AID_BOX_API_URL =
  process.env.REACT_APP_AIDBOX_URL || "https://app-dev.recurohealth.com";

export const http = (state: RootState) => {
  const token = state.user.token;
  const client = axios.create({
    baseURL: AID_BOX_API_URL,
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return client;
};

const fetchQuestionnaires = (
  state: RootState,
  params: FetchQuestionnairesParams
) => {
  return http(state).get("Questionnaire/$get-questionnaires", {
    params,
  });
};

const fetchUserResponses = async (state: RootState) => {
  return http(state).get(`Patient/$questionnaire-responses`);
};

const updateUserResponse = (state: RootState) => {
  const resource = state.questionnaire.responses.find(
    (elem) => elem.questionnaire === state.questionnaire.activeQuestionnaire
  );
  return http(state).put("/Patient/$update-questionnaire-response", resource);
};

export { fetchQuestionnaires, fetchUserResponses, updateUserResponse };
